<div class="main-layout">
    <AppHeader />
    <main>
        <SideMenu />
        <div class="wrapper">
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </main>
    <AppFooter />
</div>